export const uriRegex = /^([-_a-zA-Z]+):([-_a-zA-Z]+):([^:/\s\]\[]+)$/;
export const uriRegexEmbed = '([-_a-zA-Z]+:[-_a-zA-Z]+:[^ :/]+)';
export const versionedUriRegex = /^([-_a-zA-Z]+):([-_a-zA-Z]+):([^:/\s\]\[]+)\/([^:/\s\]\[]+)$/;
export const getUriParts = (uri) => {
    const match = uri.match(uriRegex);
    if (!match) {
        throw new Error(`${uri} not a valid uri`);
    }
    return {
        uri: match[0],
        company: match[1],
        entityType: match[2],
        namespace: `${match[1]}:${match[2]}`,
        idPart: match[3],
    };
};
export const getVersionedUriParts = (versionedUri) => {
    const match = versionedUri.match(versionedUriRegex);
    if (!match) {
        throw new Error(`not a valid versioned uri ${versionedUri}`);
    }
    return {
        versionedUri: match[0],
        company: match[1],
        entityType: match[2],
        namespace: `${match[1]}:${match[2]}`,
        idPart: match[3],
        baseUri: `${match[1]}:${match[2]}:${match[3]}`,
        versionPart: match[4],
    };
};
//# sourceMappingURL=regex.js.map